import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "@phosphor-icons/react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_COLORS = {
  create: "bg-emerald-100 text-emerald-700 border-emerald-200",
  delete: "bg-red-100 text-red-700 border-red-200",
  update: "bg-blue-100 text-blue-700 border-blue-200",
  role_change: "bg-violet-100 text-violet-700 border-violet-200",
  status_change: "bg-amber-100 text-amber-700 border-amber-200",
};

const fmt = (v) => (v == null ? "—" : typeof v === "object" ? Object.entries(v).map(([k, val]) => `${k}: ${val}`).join(", ") : String(v));

export default function AuditLog() {
  const logs = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit")).data }).data || [];
  return (
    <div>
      <div className="flex items-center gap-2.5 mb-1">
        <ShieldCheck className="h-6 w-6 text-slate-700" weight="fill" />
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Audit Log</h1>
      </div>
      <p className="text-sm text-slate-500 mb-6">Owner-only. Records job creation/deletion, cost changes, role changes and machine status changes.</p>

      <div className="border border-slate-200 rounded-lg bg-white overflow-x-auto">
        <Table>
          <TableHeader className="bg-slate-50"><TableRow>
            <TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Table</TableHead>
            <TableHead>Record</TableHead><TableHead>Old</TableHead><TableHead>New</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow><TableCell colSpan={7} className="text-center py-10 text-slate-400">No audit entries yet.</TableCell></TableRow>
            ) : logs.map((l, i) => (
              <TableRow key={l.id || i} data-testid={`audit-row-${i}`}>
                <TableCell className="text-xs whitespace-nowrap">{new Date(l.timestamp).toLocaleString("en-IN")}</TableCell>
                <TableCell>{l.user_name}</TableCell>
                <TableCell><Badge variant="outline" className={ACTION_COLORS[l.action] || ""}>{l.action}</Badge></TableCell>
                <TableCell className="font-mono text-xs">{l.table}</TableCell>
                <TableCell className="font-mono text-xs">{(l.record_id || "").slice(0, 8)}</TableCell>
                <TableCell className="text-xs text-slate-500">{fmt(l.old_value)}</TableCell>
                <TableCell className="text-xs text-slate-500">{fmt(l.new_value)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
